import { Select } from '@mantine/core'

// Locations
import useLocations from '@/hooks/useLocations'

// User
import useMe from '@/hooks/useMe'

export default function LocationSelect({
    label,
    value,
    onChange,
    withAll = false,
    withCustomer = false,
    onlyFulfillOrdersLocations = false,
    onlyProductComponentsLocations = false,
    ...props
}) {
    // User
    const { isAdmin } = useMe()

    const locations = useLocations()

    const locationsFiltered = locations?.filter((location) => {
        if (onlyFulfillOrdersLocations) {
            return location.can_fulfill_orders == true
        }

        if (onlyProductComponentsLocations) {
            return location.can_product_components == true
        }

        return true
    })

    const locationsBaseOptions =
        locationsFiltered?.map((location) => ({
            value: String(location.id),
            label: location.name,
        })) ?? []

    let locationsOptions = [...locationsBaseOptions]

    if (withAll)
        locationsOptions.unshift({
            value: 'all',
            label: 'Tous les emplacements',
        })

    if (withCustomer)
        locationsOptions.unshift({
            value: 'customer',
            label: 'With customer',
        })

    if (!isAdmin) {
        locationsOptions = locationsOptions.filter(
            (location) => location.value === '1'
        )
    }

    return (
        <div>
            <Select
                className="min-w-[280px]"
                label={label}
                data={locationsOptions}
                value={isAdmin ? String(value) : '1'}
                onChange={onChange}
                allowDeselect={false}
                disabled={!isAdmin}
                maxDropdownHeight={300}
                {...props}
            />
        </div>
    )
}
